/**
 * DashboardStatisticsTrendRes 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'

/**
 * DashboardStatisticsTrendRes
 */
export interface DashboardStatisticsTrendRes {
  /** 日期列表 */
  dates?: string[]
  /** 用户新增数据 */
  users?: number[]
  /** 帖子新增数据 */
  posts?: number[]
  /** 大本营新增数据 */
  camp_groups?: number[]
  /** 对线群新增数据 */
  battle_groups?: number[]
  /** 当前页码 */
  page?: number
  /** 每页天数 */
  page_size?: number
  /** 总天数 */
  total_days?: number
  /** 总页数 */
  total_pages?: number
}

/**
 * DashboardStatisticsTrendRes Schema
 */
export const DashboardStatisticsTrendResSchema: SchemaDefinition = {
  properties: {
    dates: {
      description: '日期列表',
      format: '[]string',
      items: {
        format: 'string',
        type: 'string',
      },
      type: 'array',
      label: '日期列表',
    },
    users: {
      description: '用户新增数据',
      format: '[]int',
      items: {
        format: 'int',
        type: 'integer',
      },
      type: 'array',
      label: '用户新增数据',
    },
    posts: {
      description: '帖子新增数据',
      format: '[]int',
      items: {
        format: 'int',
        type: 'integer',
      },
      type: 'array',
      label: '帖子新增数据',
    },
    camp_groups: {
      description: '大本营新增数据',
      format: '[]int',
      items: {
        format: 'int',
        type: 'integer',
      },
      type: 'array',
      label: '大本营新增数据',
    },
    battle_groups: {
      description: '对线群新增数据',
      format: '[]int',
      items: {
        format: 'int',
        type: 'integer',
      },
      type: 'array',
      label: '对线群新增数据',
    },
    page: {
      description: '当前页码',
      format: 'int',
      type: 'integer',
      label: '当前页码',
    },
    page_size: {
      description: '每页天数',
      format: 'int',
      type: 'integer',
      label: '每页天数',
    },
    total_days: {
      description: '总天数',
      format: 'int',
      type: 'integer',
      label: '总天数',
    },
    total_pages: {
      description: '总页数',
      format: 'int',
      type: 'integer',
      label: '总页数',
    },
  },
  type: 'object',
}
